import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { of} from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class ConfigService {

  private router = inject(Router);

  constructor(private http: HttpClient) { }

  getDashboardConfig(configFileName: string): Observable<any> {
    return this.http.get(`/assets/dashboard-config/${configFileName}`);
  }

  private buildPayload(requestParamFilters: any): any {
    const currentPath = this.router.url.split('?')[0]; // Remove query params
    const dashboardName = currentPath.startsWith('/') ? currentPath.substring(1) : currentPath;

    let staticFilters: any[] = [];

    if (dashboardName === 'customer-overview') {
      staticFilters = [
        {
          attributeName: 'customer_name',
          operator: '!=',
          attributeValues: ['NA'],
          logicalOperator: 'AND',
        },
      ];
    } else if (dashboardName !== 'opportunity-overview') {
      staticFilters = [
        {
          attributeName: 'customer_name',
          operator: '!=',
          attributeValues: ['NA'],
          logicalOperator: 'AND',
        },
        {
          attributeName: 'latest_shop_order_flag',
          operator: '=',
          attributeValues: [true],
          logicalOperator: 'AND',
        },
      ];
    }

    const dynamicFilters = Object.entries(requestParamFilters)
      .map(([key, value]) => {
        const rawValues = Array.isArray(value) ? value.flat(Infinity) : [value]; // recursively flatten the array to any depth eg. [[[]]].
        const updatedValues = rawValues.filter(v =>
          v !== null &&
          v !== undefined &&
          v !== '' &&
          !(Array.isArray(v) && v.length === 0)
        );

      if (updatedValues?.length === 0) return null;

        return {
          attributeName: key,
          operator: updatedValues.length > 1 ? 'IN' : '=',
          attributeValues: updatedValues,
          logicalOperator: 'AND'
        };
      })
    .filter((filter): filter is NonNullable<typeof filter> => filter !== null); //emoves null entries from the array.

    // Adjust logicalOperator handling
    if (dynamicFilters.length > 0) {
      dynamicFilters[dynamicFilters.length - 1].logicalOperator = '';
      if (staticFilters.length > 0) {
        staticFilters[staticFilters.length - 1].logicalOperator = 'AND';
      }
    } else {
      if (staticFilters.length > 0) {
        staticFilters[staticFilters.length - 1].logicalOperator = '';
      }
    }

    return {
      filter: {
        where: [...staticFilters, ...dynamicFilters],
        join: {},
        orderBy: {}
      }
    };
  }




  private buildQueryParams(queryParamFilters: any): HttpParams {
    let params = new HttpParams();
    for (const key in queryParamFilters) {
      const value = queryParamFilters[key];

      if (key === 'slider_range' && Array.isArray(value) && value.length === 2) {
        const start = parseInt(value[0], 10);
        const end = parseInt(value[1], 10);

        params = params.set('startRange', start.toString());
        console.log('Start Range:', start);
        params = params.set('endRange', end.toString());
      }
      else if (key === 'button') {
        params = params.set(value[0], true);
      }
      else {
        params = params.set(key, Array.isArray(value) ? value.join(',') : value);
      }
    }

    return params;
  }


  //  getConfig(
  //   url: string,
  //   filters?: any,
  //   method = 'post',
  //   isTable = false,
  //   token?: string // Add the token parameter here
  // ): Observable<any> {
  //   const useQueryParams = filters?.useQueryParams === true;

  //   if (filters && 'useQueryParams' in filters) {
  //     delete filters.useQueryParams;
  //   }

  //   const payload = this.buildPayload(filters?.requestParams || {});
  //   const queryParams = useQueryParams
  //     ? this.buildQueryParams(filters?.queryParams || {})
  //     : new HttpParams();

  //   if (!!isTable) {
  //     payload.filter.where = payload.filter.where.filter((elm: any) => elm.attributeName === 'customer_spec');
  //   }

  //   // Add Bearer token to the headers
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }

  //   // Send HTTP request with headers (Bearer token)
  //   if (method === 'post') {
  //     return this.http.post<any>(url, payload, { params: queryParams, headers });
  //   } else {
  //     return this.http.get<any>(url, { params: queryParams, headers });
  //   }
  // }

  getConfig(url: string, filters?: any, method = 'post', isTable = false ,token?:string): Observable<any> {
  const useQueryParams = filters?.useQueryParams === true;
  console.log("Token in config service:", token);

  if (filters && 'useQueryParams' in filters) {
    delete filters.useQueryParams;
  }

  const payload = this.buildPayload(filters?.requestParams || {});
  const queryParams = useQueryParams
    ? this.buildQueryParams(filters?.queryParams || {})
    : new HttpParams();

  if (!!isTable) {
    payload.filter.where = payload.filter.where.filter((elm: any) => elm.attributeName === 'customer_spec');
  }

return method === 'post'
  ? this.http.post<any>(url, payload, { params: queryParams, headers: token ? new HttpHeaders().set('Authorization', `Bearer ${token}`) : undefined })
  : this.http.get(url, { params: queryParams, headers: token ? new HttpHeaders().set('Authorization', `Bearer ${token}`) : undefined });
}


 getDropdownOptions(url: string, payload: any, token: string): Observable<any> {
  console.log('Dropdown options payload', payload);
  console.log('Dropdown options url', url);

  // Set Authorization header with Bearer token
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  // Send POST request with headers
  // return this.http.post(url, payload, { headers });
  return of([]);
}


  getData(url: string) {
    return this.http.get(url)
  }
}
